import styled from 'styled-components';
import { bodySmall } from '../styles/text';

export const Description = styled.div`
  ${bodySmall}
  color: ${({ theme }) => theme.colors.gray666};
  white-space: break-spaces;
`;
